import React from 'react';
import PropTypes from 'prop-types';

import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';

import styles from './WorkbenchValue.css';
import WorkbenchValueEditInput from './WorkbenchValueEditInput';
import { truncateString } from './helpers';
import TrashIcon from 'zignal-landscape/lib/Icon/TrashIcon';
import EditIcon from 'zignal-landscape/lib/Icon/EditIcon';

class WorkbenchValue extends React.Component {
  constructor(props) {
    super(props);

    this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleEditCancel = this.handleEditCancel.bind(this);

    this.state = {
      isConfirmationModalOpen: false,
      isEditing: false,
      editingFieldValueName: this.props.value.name
    };
  }

  handleConfirmDelete() {
    const {
      field,
      onDelete,
      value
    } = this.props;
    this.setState({ isConfirmationModalOpen: false });
    onDelete(field._id, value._id);
  }

  handleDelete() {
    this.setState({ isConfirmationModalOpen: true });
  }

  handleEdit() {
    this.setState({isEditing: true});
  }

  handleEditCancel() {
    this.setState({isEditing: false});
  }

  closeConfirmationModal() {
    this.setState({ isConfirmationModalOpen: false });
  }

  render() {
    const {field, isShared, value, onUpdate} = this.props;
    const {isEditing, isConfirmationModalOpen} = this.state;
    const isEditable = (field.type === 'Categorical' || field.type === 'Ordinal') && (! isShared);
    const editIcons = (
      <span className={styles.actionsContainer}>
        <span className={styles.actionDelete} onClick={this.handleDelete}><TrashIcon /></span>
        <span className={styles.actionEdit} onClick={this.handleEdit}><EditIcon /></span>
      </span>
    );

    const confirmationModal = (
      <ConfirmationModal
        confirmStyle="delete"
        confirmText="Delete"
        isOpen={isConfirmationModalOpen}
        onCancel={this.closeConfirmationModal}
        onConfirm={this.handleConfirmDelete}
        title="Delete Attribute Value"
      >
        <p className={styles.confirmationModalContent}>
          Are you sure you want to delete the <strong>{value.name}</strong>
          &nbsp;attribute value?
        </p>
      </ConfirmationModal>
    );

    const valueNameForDisplay = truncateString(value.name, 64);
    const valueLabel = (
      <div className={styles.fieldLabel}>
        <span className={styles.valueName}>{valueNameForDisplay}</span>
        {isEditable ? editIcons : null}
      </div>
    );

    const editingLabel = (
      <WorkbenchValueEditInput
        field={field}
        value={value}
        onUpdate={onUpdate}
        onCancel={this.handleEditCancel}
      />
    );

    return (
      <li className={styles.valueListItem}>
        {isEditing ? editingLabel : valueLabel}
        {confirmationModal}
      </li>
    );
  }
}

WorkbenchValue.propTypes = {
  value: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  isShared: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
};

export default WorkbenchValue;
